(async function(algolia) {
  const config = algolia.config || {};
  const translations = algolia.translations || {};
  const indexSuffix = await config.index_suffix || '';
  const indexPrefix = config.index_prefix || 'shopify_';
  const sortOrderBase = `${indexPrefix}products${indexSuffix}`;

  // Fallback
  algolia.sortOrders = [
    { value: sortOrderBase, label: translations.relevance || 'Relevance' }
  ];

  (config.sort_orders || []).forEach((sort) => {
    if (sort.asc?.active) {
      algolia.sortOrders.push({
        value: `${sortOrderBase}_${sort.key}_asc`,
        label: sort.asc.title
      });
    }
    if (sort.desc?.active) {
      algolia.sortOrders.push({
        value: `${sortOrderBase}_${sort.key}_desc`,
        label: sort.desc.title
      });
    }
  });

  const currentCollectionId = algolia.current_collection_id;
  const collectionSorts = config.collection_sort_orders?.[currentCollectionId] || config.collection_sort_orders?.default;

  if (collectionSorts) {
    algolia.collectionSortOrders = [
      { value: sortOrderBase, label: translations.relevance || 'Relevance' }
    ];
    collectionSorts.forEach((sort) => {
      if (sort.asc?.active) {
        algolia.collectionSortOrders.push({
          value: `${sortOrderBase}_${sort.key}_asc`,
          label: sort.asc.title
        });
      }
      if (sort.desc?.active) {
        algolia.collectionSortOrders.push({
          value: `${sortOrderBase}_${sort.key}_desc`,
          label: sort.desc.title
        });
      }
    });
  }

  // console.log('✅ sortOrders:', algolia.sortOrders);
  // console.log('✅ collectionSortOrders:', algolia.collectionSortOrders);
})(window.algoliaShopify);
